import React from 'react';
import { useHydrationFriendlyAsPath } from 'ap-admin-components/lib/Utilities/Hooks/useHydrationFriendlyAsPath';
import { Overlays, OverlaysDispatchAction } from 'ap-admin-components/lib/Components/Overlays';
import Head from 'next/head';
import Header from '@/layout/header/Header';

export function handleOverlayClosing(
  hash: string,
  prevHash: string,
  overlays: string[],
  closeOverlay: React.Dispatch<OverlaysDispatchAction>
) {
  if (hash !== prevHash) {
    if (hash && hash !== '') {
      if (overlays.length > 1 && hash && prevHash) {
        const lastOverlay = overlays[overlays.length - 1];
        if (hash !== lastOverlay) {
          closeOverlay({
            action: 'close',
            name: lastOverlay,
          });
        }
      }
    } else if (overlays.length > 0) {
      closeOverlay({
        action: 'close',
        name: 'all',
      });
    }
  }
}

export const DefaultLayout: React.FC<React.PropsWithChildren<{ title?: string }>> = (props) => {
  const asPath = useHydrationFriendlyAsPath();
  const { overlaysActions, openOverlays } = React.useContext(Overlays);

  const hash = asPath.indexOf('#') !== -1 ? asPath.split('#')[1] : '';

  const prevHash = React.useRef(hash);

  // Close overlay when hash gets removed
  React.useEffect(() => {
    handleOverlayClosing(hash, prevHash.current, openOverlays, overlaysActions);
    return () => {
      prevHash.current = hash;
    };
  }, [hash, prevHash, openOverlays, overlaysActions]);

  // Close overlay when unmounting
  React.useEffect(() => {
    return () => {
      overlaysActions({
        action: 'close',
        name: 'all',
      });
    };
  }, [overlaysActions]);

  return (
    <React.Fragment>
      {props.title && (
        <Head>
          <title>{props.title}</title>
          <meta
            content={props.title}
            name="description"
          />
        </Head>
      )}
      <Header />
      {props.children}
      {/* Placeholder <div/> for <Footer/> CSS */}
      <div />
    </React.Fragment>
  );
};
